(function () {
  if (window.woPilotHoverZoomBound) return;
  window.woPilotHoverZoomBound = true;

  const selector = '#main-product.wo-product-enhanced .l4pr .swiper-slide-active a[data-fancybox][data-media-type="image"]';
  const supported = window.matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
  let activePicture = null;
  let activeImage = null;
  let imageBounds = null;

  function reset() {
    if (activePicture) activePicture.classList.remove('wo-loupe-active');
    if (activeImage) {
      activeImage.style.removeProperty('--wo-loupe-x');
      activeImage.style.removeProperty('--wo-loupe-y');
    }
    activePicture = null;
    activeImage = null;
    imageBounds = null;
  }

  document.addEventListener('pointermove', function (event) {
    if (!supported.matches || event.pointerType !== 'mouse' || event.buttons !== 0 || document.querySelector('.fancybox__container')) {
      reset();
      return;
    }
    const anchor = event.target instanceof Element ? event.target.closest(selector) : null;
    const image = anchor ? anchor.querySelector('picture > img') : null;
    const picture = image ? image.parentElement : null;
    if (!picture || !image.complete || image.naturalWidth === 0) {
      reset();
      return;
    }
    if (picture !== activePicture) {
      reset();
      activePicture = picture;
      activeImage = image;
      imageBounds = image.getBoundingClientRect();
    }
    if (!imageBounds.width || !imageBounds.height) return;
    const x = Math.max(0, Math.min(100, (event.clientX - imageBounds.left) / imageBounds.width * 100));
    const y = Math.max(0, Math.min(100, (event.clientY - imageBounds.top) / imageBounds.height * 100));
    image.style.setProperty('--wo-loupe-x', x.toFixed(2) + '%');
    image.style.setProperty('--wo-loupe-y', y.toFixed(2) + '%');
    picture.classList.add('wo-loupe-active');
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    if (activePicture && (!(event.relatedTarget instanceof Node) || !activePicture.contains(event.relatedTarget))) reset();
  }, { passive: true });
  document.addEventListener('pointerdown', reset, true);
  document.addEventListener('click', reset, true);
  document.addEventListener('keydown', reset, true);
  document.addEventListener('change', reset, true);
  window.addEventListener('resize', reset, { passive: true });
  window.addEventListener('scroll', reset, { passive: true, capture: true });
  window.addEventListener('blur', reset);
  window.addEventListener('pagehide', reset);
  supported.addEventListener('change', reset);

  new MutationObserver(function () {
    if (activePicture && (!activePicture.isConnected || !activePicture.closest('.swiper-slide-active'))) reset();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
